import React, { Component } from 'react'
import './style.css'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import Author from './controller/Author'

import Menu from './components/menu'
import Home from './components/home'

import FlashCard from './components/flashcard'
import Mustom from './components/mustom'
import Peace from './components/peace'
import Type from './components/type'
import Movie from './components/movie'
import About from './components/about'
import Login from './components/etc/Login'
import Denied from './components/etc/Denied'
import NoMatch from './components/etc/Nomatch'
import Download from './components/etc/Download'

import Docs from './components/docs'
import Memo from './components/memo'
import Calendar from './components/calendar'
import Share from './components/share'
import Sticky from './components/sticky'
import Plan from './components/plan'


export default class App extends Component {
    state = {
        isMobile : false,
        isLogin : false
    }
    
    componentDidMount() {
        Author(cb => {
            this.setState({ isLogin : cb })
        })

        let winWidth = window.innerWidth
        winWidth <= 992 ? this.setState({ isMobile : true }) : this.setState({ isMobile : false })
       
    }
  
    render() {
        return (
            <Router>
            	<React.Fragment>
                    <Menu isMobile = { this.state.isMobile } />
                    <Switch>
                        <Route exact path = '/' render = { () => <Home isMobile={this.state.isMobile} /> } />
                        <Route path = '/mustom' component = { Mustom } />
                        <Route path = '/secret' component = { Denied } />
                        <Route path = '/flashcard' render = { () => <FlashCard isLogin={this.state.isLogin} /> } />
                        <Route path = '/peace' component = { Peace } />
                        <Route path = '/type' component = { Type } />
                        <Route path = '/movie' component = { Movie } />
                        <Route path = '/misterp' component = { Login } />
                        <Route path = '/memo' render = { () => <Memo isLogin={this.state.isLogin} /> } />
                        <Route path = '/docs' render = { () => <Docs isMobile={this.state.isMobile} isLogin={this.state.isLogin} /> } />
                        <Route path = '/calendar' render = { () => <Calendar isLogin={this.state.isLogin} /> } />
                        <Route path = '/share' component = { Share } />
                        <Route path = '/sticky' render = { () => <Sticky isLogin={this.state.isLogin} /> } />
                        <Route path = '/about' component = { About } />
                        <Route path = '/plan' render = { () => <Plan isLogin={this.state.isLogin} /> } />
                        <Route path = '/download' component = { Download } />
                        <Route component = { NoMatch } />
                    </Switch>
                </React.Fragment>
            </Router>
        )
    }
}






// WEBPACK FOOTER //
// ./src/App.js